var map = {
	"./bar-hire": 12,
	"./bar-hire.png": 12,
	"./breakfast": 13,
	"./breakfast.png": 13,
	"./brunch": 14,
	"./brunch.png": 14,
	"./caterers": 15,
	"./caterers.png": 15,
	"./chefs-1": 16,
	"./chefs-1.png": 16,
	"./chefs-2": 17,
	"./chefs-2.png": 17,
	"./chefs-3": 18,
	"./chefs-3.png": 18,
	"./chefs-4": 19,
	"./chefs-4.png": 19,
	"./cooking": 20,
	"./cooking.png": 20,
	"./deserts": 21,
	"./deserts.png": 21,
	"./favicon": 22,
	"./favicon.ico": 73,
	"./favicon.png": 22,
	"./group-meal": 23,
	"./group-meal.png": 23,
	"./map-bg": 24,
	"./map-bg.png": 24,
	"./svg/burger": 25,
	"./svg/burger.svg": 25,
	"./svg/carousel_arrow": 26,
	"./svg/carousel_arrow.svg": 26,
	"./svg/cta_arrow": 27,
	"./svg/cta_arrow.svg": 27,
	"./svg/diagonal_arrow": 28,
	"./svg/diagonal_arrow.svg": 28,
	"./svg/dot": 29,
	"./svg/dot.svg": 29,
	"./svg/email-icon": 30,
	"./svg/email-icon.svg": 30,
	"./svg/facebook-social": 31,
	"./svg/facebook-social.svg": 31,
	"./svg/fb_icon": 32,
	"./svg/fb_icon.svg": 32,
	"./svg/full_logo": 33,
	"./svg/full_logo.svg": 33,
	"./svg/hero_down_arrow": 34,
	"./svg/hero_down_arrow.svg": 34,
	"./svg/icon_bg": 35,
	"./svg/icon_bg.svg": 35,
	"./svg/icon_bg_blue": 36,
	"./svg/icon_bg_blue.svg": 36,
	"./svg/icon_logo": 37,
	"./svg/icon_logo.svg": 37,
	"./svg/icon_logo_blue": 38,
	"./svg/icon_logo_blue.svg": 38,
	"./svg/icon_logo_white": 39,
	"./svg/icon_logo_white.svg": 39,
	"./svg/in_icon": 40,
	"./svg/in_icon.svg": 40,
	"./svg/instagram-social": 41,
	"./svg/instagram-social.svg": 41,
	"./svg/li_icon": 42,
	"./svg/li_icon.svg": 42,
	"./svg/line": 43,
	"./svg/line.svg": 43,
	"./svg/linkedin-social": 44,
	"./svg/linkedin-social.svg": 44,
	"./svg/phone": 45,
	"./svg/phone-icon": 46,
	"./svg/phone-icon.svg": 46,
	"./svg/phone.svg": 45,
	"./svg/single-logo-icon": 47,
	"./svg/single-logo-icon.svg": 47,
	"./wedding": 48,
	"./wedding-2": 49,
	"./wedding-2.png": 49,
	"./wedding-marque": 50,
	"./wedding-marque.png": 50,
	"./wedding-party": 51,
	"./wedding-party.png": 51,
	"./wedding.png": 48,
	"./wine-glass": 52,
	"./wine-glass.png": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;